import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { fetchApi } from '../../services/api';
import LoadingPanel from '../LoadingPanel';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{ }>;

type State = {
    isLoading: boolean;
    users: UserData[];
    links: ApiLink[];
}

type UserData = {
    UserID: string;
    UserName: string;
    Email: string;
    Active: boolean;
}

class Users extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            users: [],
            links: [],
            isLoading: false
        }
    }

    public componentWillMount() {
        this.requestUsers();
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Users" />
            <div className="row">
                <div className="col">
                    <h1>Users</h1>
                </div>
                <div className="col text-right">
                    {this.state.links.find(x => x.Rel === "TenantProfile") && <Link
                        role="button"
                        className="btn btn-secondary"
                        to={ '/company/profile' }
                    >
                        Company Profile
                    </Link>}
                    {this.state.links.find(x => x.Rel === "AddUser") && <React.Fragment>
                        &nbsp;&nbsp;
                        <Link
                            role="button"
                            className="btn btn-primary"
                            to={ '/user/new/profile' }
                        >
                            Add User
                        </Link>
                    </React.Fragment>}
                </div>
            </div>
            {this.state.isLoading && <LoadingPanel />}
            { this.renderFacilitiesTable() }
        </React.Fragment>;
    }

    private renderFacilitiesTable() {
        return <table className='table'>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Active</th>
                </tr>
            </thead>
            <tbody>
                {this.state.users.map((user, index) =>
                    <tr key={ index }>
                        <td>
                            <Link to={ `/user/${ user.UserID }/profile` }>
                                {user.UserName}
                            </Link>
                        </td>
                        <td>{user.Email}</td>
                        <td>{user.Active}</td>
                    </tr>
                )}
            </tbody>
        </table>;
    }

    private requestUsers() {
        this.setState({ isLoading: true });
        fetchApi(`api/User/List`)
            .then((response: { Users: UserData[], Links: ApiLink[] }) => {
                this.setState({ users: response.Users, links: response.Links, isLoading: false });
            });
    }
}

export default Users;
